<template>
  <section id="total" class="border_1px_top px-2">
    <span class="total_left radio_wrapper" @click="selectAll()">
      {{ vaildCommoditiesNum === selectListLength ? "清空选择" : "全选" }}
    </span>
    <span class="total_right">
      <span class="text-sm">
        合计：
        <span class="price_wrapper text-base text-red font-semibold">
          {{ curTotalPrice.toFixed(2) }}
        </span>
        <span class="settle_wrapper">
          <button class="settle_btn py-2 rounded-full" @click="submitOrder()">
            {{ isEditingAll ? "删除" : "结算" }}({{ selectListLength }})
          </button>
        </span>
      </span>
    </span>
  </section>
</template>
<script >
export default {
  props: [
    "selectListLength",
    "vaildCommoditiesNum",
    "curTotalPrice",
    "isEditingAll",
  ],

  data() {
    return {
      selectAllStatus: false,
    };
  },
  methods: {
    selectAll() {
      this.$emit("getSelectAllFeedback", this.selectAllStatus);
    },

    submitOrder() {
      this.$emit("getSubmitOrderFeedback");
    },
  },
};
</script>

<style lang="less" slot-scope>
#total {
  box-sizing: border-box;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: calc(3.1rem + env(safe-area-inset-bottom));
  width: 100%;
  background: #ffffff;
}

.total_left {
  position: relative;
  margin-left: 20px;
  font-size: 28px;
}

.radio_wrapper {
  display: flex;
  align-items: center;
}

.total_right {
  font-size: 16px;
}

.settle_btn {
  width: 200px;
  margin-left: 24px;

  background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);

  color: #ffffff;
  font-size: 28px;
}
</style>
